import { compose, createStore, applyMiddleware } from 'redux';
import thunkMiddleware from 'redux-thunk';
import { reducer } from './reducer';
import { composeWithDevTools } from 'redux-devtools-extension';

export default (props) => {
	let errors = {}
  let initialFormData = {
    formName: "WarrantyStandard",
    country: props.country || 'US',
    countrySelected: 'US',
    registrantType: 'homeowner',
    ownerAddressSameAsProperty: true,
    installDateMonth: '1',
    installDateDay: '1',
    installDateYear: '',
    email: '',
    squares: '',
    didAcknowledgeBigRoof: null,
    installingContractor: '',
    installingContractorData: null,
    proofOfPurchaseFiles: [],
    preferredContactMethod: '',
    homeownerPhone: '',
    propertyOwnerFName: '',
    propertyOwnerLName: '',
    shingleLine: false,
    shingleColor: false,
    selections: "suggested",
    propertyAddress: {
      street: null,
      streetLine2: null,
      city: null,
      state: null,
      zip: null
    },
    components: {
      ventilation_products: 'NO',
      //... populated by endpoint. default for testing
    },
    ownerAddress: {
      street: null,
      streetLine2: null,
      city: null,
      state: null,
      zip: null
    },
    contractorAddress: {
      street: null,
      streetLine2: null,
      city: null,
      state: null,
      zip: null
    },
  }

	const initialState = {
		railsProps: props,
    step: 1,
		formData: initialFormData,
		appData: {},
		appErrors: errors,
		dataComplaints: {},
		showComplaints: false,
		isFetching: false,
    completedSteps: { 0: true },
    metadata: {},
    showModal: false,
    showErrorModal: false,
    disableSubmitBtn: false,
    viaClaimForm: false,
    claimData: null
	};

  const composedStore = compose(
		composeWithDevTools(applyMiddleware(thunkMiddleware))
	);
	const storeCreator = composedStore(createStore);
	const store = storeCreator(reducer, initialState);

  return store
};
